export default __webpack_public_path__ + "static/media/user-circle.ad7453a7.svg";